/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Action } from '../../../../components/ActionsCard/ActionCard';
import { strings } from '../../../../intl/Strings';
import { LftSidePaneActionId } from '../shared';

export const LftSidePaneBrainstormAction = (onClickHandler?: () => void): Action => ({
    id: LftSidePaneActionId.Brainstorm,
    checked: false,
    primaryContent: strings.getString('lftSidePaneBrainstormTitle'),
    secondaryContent: strings.getString('lftSidePaneBrainstormContent'),
    onClick: () => {
        onClickHandler?.();
    }
});
